import React, { useState } from 'react';
import { ScrollView, View, TouchableOpacity } from 'react-native';
import MyAppText from '../../MyAppText';
import { faLocationDot, faPlay, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { faCalendarCheck } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import OccurrenceVideoModal from './OccurrenceVideoModal';
import { translate } from '../../../services/translate';
import { dispatchService } from '../../../services/central-api/dispatch';
import { faCameraCctv } from '@fortawesome/pro-solid-svg-icons';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

export default function SceneChangeDetection({
    occurrence, navigation
}: {
    occurrence: Occurrence;
    navigation: Navigation;
}) {
    const { styles, theme } = useStyles(styleSheet);

    const [isModalVisible, setModalVisible] = useState(false);

    if (occurrence.triggerType != 'defocus' && occurrence.triggerType != 'scenechangedetection') {
        return <></>;
    }

    return (
        <ScrollView >
            <View style={{ gap: 10 }}>
                <MyAppText style={styles.nameText}>
                    {occurrence.resume.serialNo}
                </MyAppText>
                <View style={{ gap: 5 }}>
                    <View style={{ flexDirection: 'row', alignItems: 'center', columnGap: 5 }} >
                        <FontAwesomeIcon icon={faPlay} style={{ width: 22 }} color={theme.colors.iconColor} />
                        <TouchableOpacity onPress={() => setModalVisible(true)}>
                            <MyAppText style={[styles.detectionInfoText, { textDecorationLine: 'underline' }]}>
                                {translate('watchVideo')}
                            </MyAppText>
                        </TouchableOpacity>
                    </View>
                    <View style={{ flexDirection: 'row', alignItems: 'center', columnGap: 5 }} >
                        <FontAwesomeIcon icon={faCameraCctv as IconDefinition} style={{ width: 22 }} color={theme.colors.iconColor} />
                        <TouchableOpacity onPress={() => {
                            navigation.navigate('CameraPlayer', { id: occurrence.externalReference?.id });
                        }}>
                            <MyAppText style={styles.detectionInfoText}>
                                {occurrence.externalReference?.title}
                            </MyAppText>
                        </TouchableOpacity>
                    </View>
                    <View style={{ flexDirection: 'row', alignItems: 'center', columnGap: 5 }}>
                        <FontAwesomeIcon icon={faCalendarCheck} style={{ width: 22 }} color={theme.colors.iconColor} />
                        <MyAppText style={styles.detectionInfoText}>
                            {moment(new Date(occurrence.resume.time)).format('DD/MM/YYYY HH:mm:ss')}
                        </MyAppText>
                    </View>
                    <View style={{ flexDirection: 'row', alignItems: 'center', columnGap: 5 }}>
                        <FontAwesomeIcon icon={faLocationDot} style={{ width: 22 }} color={theme.colors.iconColor} />
                        <MyAppText style={styles.detectionInfoText}>
                            {occurrence.externalReference?.address}
                        </MyAppText>
                    </View>

                </View>
            </View>
            <OccurrenceVideoModal
                occurrenceId={occurrence.id || 0}
                isModalVisible={isModalVisible}
                setModalVisible={setModalVisible}
                occurrenceTime={new Date(occurrence.resume.time).getTime()}
                apiService={dispatchService}
            />
        </ScrollView>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    nameText: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 20
    },
    detectionInfoText: {
        color: theme.colors.textColor,
        fontSize: 16
    },
}));
